.turnIntoIcon {
  display: flex;
  align-items: center;
  gap: 8px;
}
